import { DynamicAttributeValueInput } from "gql/graphql";
import { FilterObject } from "../model/types";

export function formFieldsToJson(value: DynamicAttributeValueInput[]) {
  const filters = value.reduce((res, elem) => {
    const { attributeCode, value } = elem;

    if (value === null || value === "") {
      return res;
    }

    res[attributeCode] = value;

    return res;
  }, {} as FilterObject);

  const result: FilterObject | null =
    Object.keys(filters).length === 0 ? null : filters;

  return result;
}
